import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createMemberJournal = ({ churchId, memberJournalData }) => {
  return axios.post(`/churches/${churchId}/member-journals`, memberJournalData);
};

export const useCreateMemberJournal = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("member-journals");

      setNotification({
        type: "success",
        message: "Member journal created successfully!"
      });
    },
    ...config,
    mutationFn: createMemberJournal
  });
};
